<div class="section" [class.disabled]="disabled()">
    <div class="section-title" [class.disabled]="disabled()">
        <p>{{title()}}</p>
        @if (showTitleAction()) {
            <app-link iconClass="dx-icon-trash" [disabled]="disabled()" (onClick)="titleActionClick('')"></app-link>
        }
    </div>

    <div class="section-content">
        <ng-content select="[body]"></ng-content>
    </div>

    @if (showFooter()) {
        <div class="section-footer">
            <ng-content select="[footer]"></ng-content>
        </div>
    }
</div>